import "./index.css";
import campusData from "./data/campus_data_joined.json";


export function makeData(len=553) {
  return campusData;
}



// WEBPACK FOOTER //
// ./src/utils.js